<ng-container [formGroup]="medicalConditionsFormGroup">
  <mat-expansion-panel [expanded]="prefilled">
    <mat-expansion-panel-header class="drawer">
      <p class="drawerTitle">
        {{ drawerTitle }} <sup class="asterisk">*</sup>
      </p>
    </mat-expansion-panel-header>
    <ng-container *ngFor="let question of childQuestions">
      <app-question [question]="question"
        [form]="medicalConditionsFormGroup"
        [multiIndex]="formGroupName + 1"
        *ngIf="isQuestionVisible(question)"
        [ngClass]="{'d-none': question.hide || question.QuestionName === 'ConditionName'}"
        [childQuestions]="getChildQuestions(question)">
      </app-question>
    </ng-container>
  </mat-expansion-panel>
</ng-container>